<nb-card>
  <nb-card-body>
    <div id="print-section" class="print-layout">
      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h1>
              <strong>
                CÔNG TY TNHH MTV TM DV<br />
                PHONG PHÚ DƯƠNG
              </strong>
            </h1>
          </td>
          <td style="text-align: center">
            <p>
              <u>Chuyên Phân Phối Sỉ & Lẻ:</u> *Ống Nhựa, Phụ Kiện <br />
              Ngành Nước & Thiết Bị Vệ Sinh Cao Cấp<br />
              *Thiết Bị Điện: Dây cáp Cadivi, Daphaco, Bóng đèn<br />
              Rạng Đông, Thiết bị điện Panasonic, Sino, PiPo...
            </p>
          </td>
        </tr>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: left">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: left">
            <label>
              ĐT: {{ shop.mobile }}
              <span *ngIf="shop.email"> - Email: {{ shop.email }} </span>
              <span *ngIf="shop.website"> - Web: {{ shop.website }} </span>
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: left">
            <label>
              NH: Sacombank chi nhánh Đồng Khỏi - CTK: Đỗ Ngọc Quyết - TK: 0700
              8971 8242
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4>PHIẾU MUA HÀNG</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              Ngày:
              {{ purchase.issueDate | date : "dd/MM/yyyy " }}
            </label>
          </td>
        </tr>
        <tr *ngIf="purchase.id.length > 6">
          <td style="text-align: center">
            <label>
              {{ "common.code" | translate }}:
              {{ purchase.id.substring(purchase.id.length - 6, 6) }}
            </label>
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <table
              width="100%"
              style="border: 0px"
              cellpadding="0"
              cellspacing="0"
            >
              <tr>
                <td style="text-align: left; width: 60%">
                  <label>
                    <strong> Khách hàng: </strong> {{ purchase.supplierName }}
                  </label>
                </td>
                <td style="text-align: left; width: 40%">
                  <label>
                    <strong> ĐT: </strong> {{ purchase.supplierMobile }}
                  </label>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="text-align: left">
                  <strong> {{ "common.address" | translate }} : </strong>
                  {{ purchase.supplierAddress }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table class="table-detail">
        <thead>
          <tr style="text-align: center">
            <th>
              <strong> {{ "common.no" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.code" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.name" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.unit" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.quantity" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.unitPrice" | translate }} </strong>
            </th>
            <th>
              <strong> CK </strong>
            </th>
            <th>
              <strong> Giá sau CK </strong>
            </th>
            <th>
              <strong> {{ "common.totalAmount" | translate }} </strong>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of purchase.purchaseDetails; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.productCode }}</td>
            <td style="text-align: left">
              <label>
                {{ item.productName }}
              </label>
            </td>
            <td style="text-align: left">
              <label>
                {{ item.productUnitName }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.quantity | number : 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.price | number : 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                <span *ngIf="item.discountPercent > 0"
                  >{{ item.discountPercent.toFixed(1) }}%
                </span>
                <!-- {{ item.discountAmount | number : 0 }} -->
              </label>
            </td>
            <td style="text-align: right">
              <label *ngIf="item.discountPercent > 0">
                {{
                  (
                    item.price -
                    (item.price * item.discountPercent) / 100
                  ).toFixed(0) | number : 0
                }}
              </label>
            </td>
            <td style="text-align: right">
              {{ item.amount | number : 0 }}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr *ngIf="purchase.discountAmount > 0">
            <td colspan="8" style="text-align: right">
              <strong> {{ "common.netAmount" | translate }}: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ purchase.detailAmount | number : 0 }} </strong>
            </td>
          </tr>
          <tr *ngIf="purchase.discountAmount > 0">
            <td colspan="8" style="text-align: right">
              <strong>
                {{ "common.discount" | translate }}
                <span *ngIf="purchase.discountPercent > 0">
                  {{ purchase.discountPercent | number : 0 }}%
                </span>
                :
              </strong>
            </td>
            <td style="text-align: right">
              <strong>
                {{ purchase.discountAmount | number : 0 }}
              </strong>
            </td>
          </tr>

          <tr>
            <td colspan="8" style="text-align: right">
              <strong> {{ "common.totalAmount" | translate }}: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ purchase.totalAmount | number : 0 }} </strong>
            </td>
          </tr>
        </tfoot>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td colspan="3" class="height-1"></td>
        </tr>

        <tr>
          <td></td>
          <td></td>
          <td style="text-align: center">
            <span>
              Ngày {{ currentDate | date : "dd " }} tháng
              {{ currentDate | date : "MM " }} năm
              {{ currentDate | date : "yyyy " }}</span
            >
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <strong> Người lập phiếu </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong> Người mua hàng </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong> Người nhập kho </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>
</nb-card>
